import { render, staticRenderFns } from "./dyeingAndFinishingOrder.vue?vue&type=template&id=0648256a&scoped=true"
import script from "./dyeingAndFinishingOrder.vue?vue&type=script&lang=js"
export * from "./dyeingAndFinishingOrder.vue?vue&type=script&lang=js"
import style0 from "./dyeingAndFinishingOrder.vue?vue&type=style&index=0&id=0648256a&prod&lang=scss&scoped=true"
import style1 from "./dyeingAndFinishingOrder.vue?vue&type=style&index=1&id=0648256a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0648256a",
  null
  
)

export default component.exports